import { useState } from "react";
import ReactApexChart from "react-apexcharts";

import type { LicenseExtensionMonthData } from "./types";
import { formatCurrency, formatMonthYear } from "./utils";

type Props = {
	data: LicenseExtensionMonthData[];
};

export const LicenseMonthlyEvolutionChart: React.FC<Props> = ({ data }) => {
	const [activeTab, setActiveTab] = useState<"revenue" | "purchases">(
		"revenue",
	);

	const categories = data.map((d) => formatMonthYear(d.month));

	return (
		<div className="bg-white rounded-xl shadow-md p-6 overflow-hidden">
			<div className="flex justify-between items-center mb-6">
				<h2 className="text-lg font-semibold text-gray-700">
					Evolução Mensal — Licenças Avulsas
				</h2>
				<div className="flex bg-gray-100 rounded-lg p-1">
					<button
						className={`px-3 py-1 text-sm rounded-md transition ${
							activeTab === "revenue"
								? "bg-white shadow-sm text-purple-600"
								: "text-gray-600"
						}`}
						onClick={() => setActiveTab("revenue")}
					>
						Receita
					</button>
					<button
						className={`px-3 py-1 text-sm rounded-md transition ${
							activeTab === "purchases"
								? "bg-white shadow-sm text-purple-600"
								: "text-gray-600"
						}`}
						onClick={() => setActiveTab("purchases")}
					>
						Compras
					</button>
				</div>
			</div>

			<div className="overflow-x-auto">
				<ReactApexChart
					type={activeTab === "revenue" ? "bar" : "line"}
					height={350}
					width="100%"
					options={{
						chart: { toolbar: { show: false }, zoom: { enabled: false } },
						xaxis: {
							categories,
							labels: { style: { colors: "#64748b" } },
						},
						yaxis: {
							labels: {
								formatter: (v) =>
									activeTab === "revenue" ? formatCurrency(v) : v.toFixed(0),
								style: { colors: "#64748b" },
							},
						},
						colors: ["#9333ea"],
						dataLabels: { enabled: false },
						stroke: {
							curve: "smooth",
							width: activeTab === "revenue" ? 0 : 3,
						},
						tooltip: {
							y: {
								formatter: (v) =>
									activeTab === "revenue" ? formatCurrency(v) : v + " compras",
							},
						},
						grid: { borderColor: "#f1f5f9" },
						plotOptions:
							activeTab === "revenue"
								? { bar: { borderRadius: 6, columnWidth: "60%" } }
								: {},
					}}
					series={[
						{
							name: activeTab === "revenue" ? "Receita" : "Compras",
							data:
								activeTab === "revenue"
									? data.map((d) => d.revenue)
									: data.map((d) => d.purchaseCount),
						},
					]}
				/>
			</div>
		</div>
	);
};
